export enum AuthAction {
    Login = 'login',
    Register = 'register',
}
